<template>
  <!-- 费用报销审核 -->
  <a-modal
    title="审核报销申请单"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    width="40%"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="myForm">
      <a-form-model
        ref="formRef"
        :model="formData"
        :label-col="labelCol"
        labelAlign="right"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="审核状态">
          <a-radio-group v-model="formData.checkStatus">
            <a-radio :value="2">通过</a-radio>
            <a-radio :value="3">不通过</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="审核意见/备注">
          <a-textarea
            v-model="formData.checkComment"
            placeholder="请输入审核意见"
            allowClear
            :max-length="1000"
            :rows="4"
            showCount
            :autosize="{ minRows: 4, maxRows: 20 }"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'audit',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formData: {
        checkStatus: 2
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 12 }
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.handleCancel()
      }
    }
  },
  methods: {
    handleOk () {
      this.$post('/reimbursement/check', this.formData).then(res => {
        if (res.data.status === 1) {
          this.$message.success(res.data.message)
          this.$emit('success')
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    handleCancel () {
      this.$emit('close')
      this.formData = {
        checkId: '',
        checkStatus: 2,
        checkComment: ''
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/financialManage/expenseReim/audit.vue